<template>
	<div>
		<p class="add-event-example-sub-header">Save Time</p>
		<p class="add-event-example-content">Selecting your location pre-fills location-specific event information, such as amenities.</p>
		<p class="add-event-example-content">If this event is happening in a new spot, please <a @click="newLocation">create a new location</a> first.</p>
	</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	methods: {
		...mapActions(['setModalOpen', 'setModalProp', 'addLocationResetState']),
		newLocation() {
			this.setModalProp({ prop: 'hostProcessModal', value: false })
			this.addLocationResetState()
			this.$router.push('/host/add/location')
		}
	}
}
</script>
